export const PRICE_SECTION_DATA = 'UPDATE_PRICE_SECTION_DATA'
export const CONSGMNT_SECTION_DATA = 'UPDATE_CONSGMNT_SECTION_DATA'

export const ADD_NEW_CONSIGNMENT_ROW = "ADD_NEW_CONSIGNMENT_ROW";
export const RFC = "UPDATE_RFC";
export const REMOVE_CONSIGNMENT_ROW = "REMOVE_CONSIGNMENT_ROW";
export const CONSIGNMENT_ROW = "UPDATE_CONSIGNMENT_ROW";
export const PRICE_SECTION_ROW = "UPDATE_PRICE_SECTION_ROW";
export const DOCUMENT_CHARGE_LIST = "DOCUMENT_CHARGE_LIST";
export const BOOK_CARGO = 'BOOK_CARGO';
export const CARGO_PRINT_DATA = 'CARGO_PRINT_DATA';
export const CARGO_REPRINT_DATA = 'CARGO_REPRINT_DATA';
export const CUSTOMER_PROFILE_DETAIL = 'CUSTOMER_PROFILE_DETAIL'
export const NEAREST_STATES = 'NEAREST_STATES'
export const NEAREST_CITIES = 'NEAREST_CITIES'
export const NEAREST_BRANCH = 'NEAREST_BRANCH'
export const SELECTED_NEAREST_BRANCH = 'SELECTED_NEAREST_BRANCH'
export const RATE_WISE_PRICE_DATA = 'RATE_WISE_PRICE_DATA'
export const RATE_WISE_PRICE_DATA_REMOVE = 'RATE_WISE_PRICE_DATA_REMOVE'
